import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

/** Retired WordPress flip-book viewer URLs. */
export const Route = createFileRoute("/3d-flip-book/$")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/", location.searchStr), statusCode: 301 });
  },
});
